<template>
    <div class="config-root nfs-config-root">
        <br />
        <div class="layout nfs-layout">
            <nav class="side-nav nfs-side-nav">
                <button class="side-item nfs-side-item" :class="{ active: activeTab === 'comum' }"
                    @click="activeTab = 'comum'">
                    <i class="fa-solid fa-building icon-tab-nfse nfs-icon-tab-nfse"></i>
                    <span>Empresa</span>
                </button>

                <button class="side-item nfs-side-item" :class="{ active: activeTab === 'nfse' }"
                    @click="activeTab = 'nfse'">
                    <i class="fas fa-file-invoice icon-tab-nfse nfs-icon-tab-nfse"></i>
                    <span>NFS-e</span>
                </button>

                <button class="side-item nfs-side-item" :class="{ active: activeTab === 'nfe' }"
                    @click="activeTab = 'nfe'">
                    <i class="fas fa-file-alt icon-tab-nfse nfs-icon-tab-nfse"></i>
                    <span>NF-e</span>
                </button>
            </nav>

            <section class="content nfs-content">
                <div v-if="activeTab === 'comum'">
                    <b-tabs nav-class="subtabs nfs-subtabs" content-class="subcontent nfs-subcontent">
                        <b-tab title="Regime Tributário" active>
                            <CompanyTaxation v-model="companyTaxation" />
                        </b-tab>

                        <b-tab title="Certificado Digital">
                            <Certificate v-if="!loading" />
                        </b-tab>

                        <b-tab title="Notificação">
                            <Notificacao />
                        </b-tab>
                    </b-tabs>
                </div>

                <div v-else-if="activeTab === 'nfse'">
                    <b-tabs nav-class="subtabs nfs-subtabs" content-class="subcontent nfs-subcontent">
                        <b-tab title="Dados" active>
                            <Imposto :configCompany="configCompany" :ehSimplesNacional="ehSimplesNacional"
                                :formName="formName" :optionsNaturezaOperacao="optionsNaturezaOperacao"
                                :optionsCodigoIndicadorOperacao="optionsCodigoIndicadorOperacao"
                                :optionsTributacaoIBSCBS="optionsTributacaoIBSCBS"
                                :optionsClassificacaoTributaria="optionsClassificacaoTributaria"
                                :optionsCodigoOpcaoSimplesNacional="optionsCodigoOpcaoSimplesNacional"
                                :optionsTipoTributacao="optionsTipoTributacao"
                                :optionsRegimeApuracaoTributariaSimplesNacional="optionsRegimeApuracaoTributariaSimplesNacional"
                                :optionsRegimeEspecialTributacaoMunicipal="optionsRegimeEspecialTributacaoMunicipal"
                                :optionsSituacaoTributariaPisCofins="optionsSituacaoTributariaPisCofins"
                                :saveCompany="saveCompany" />
                        </b-tab>
                        <b-tab title="Login de Acesso">
                            <Loading :center="true" v-show="loading" />
                            <div v-if="!loading">
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <InputText title="Url de Acesso" field="name" :required="true" :maxLength="500"
                                            :disabled="configCompany.nacional" :markFormDirty="false"
                                            v-model="configCompany.urlPrefeitura" />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <InputText :disabled="configCompany.nacional" title="Login" field="name"
                                            :required="true" :maxLength="100" :markFormDirty="false"
                                            v-model="configCompany.loginPrefeitura" />
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <InputPassword :disabled="configCompany.nacional" title="Senha" field="number"
                                            :required="true" :maxLength="100" :markFormDirty="false"
                                            v-model="configCompany.senhaPrefeitura" />
                                    </b-col>
                                </b-row>
                                <div class="div-btn-save nfs-div-btn-save">
                                    <Button _key="btnSaveCompany" type="success" title="Salvar" classIcon="fas fa-save"
                                        size="medium" :clicked="saveCompany" />
                                </div>
                            </div>
                        </b-tab>
                        <b-tab title="Serviços">
                            <Taxation />
                        </b-tab>
                    </b-tabs>
                </div>
                <div v-else-if="activeTab === 'nfe'">
                    <b-tabs nav-class="subtabs nfs-subtabs" content-class="subcontent nfs-subcontent">
                        <b-tab title="CFOP" active>
                            <Cfop />
                        </b-tab>
                        <b-tab title="Natureza da Operação">
                            <NatureOperation />
                        </b-tab>
                    </b-tabs>
                </div>
            </section>
        </div>

        <br />
    </div>
</template>

<script>
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded";
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import InputPassword from "@nixweb/nixloc-ui/src/component/forms/InputPassword";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";

import Notificacao from "../notification/Notificacao.vue";
import NatureOperation from "../../../../views/modules/tax-document/NatureOperation.vue";
import Cfop from "../../../../views/modules/tax-document/Cfop.vue";
import Taxation from "../../../../views/modules/tax-document/Taxation.vue";

import Certificate from "../certificate/Certificate.vue";
import CompanyTaxation from "./CompanyTaxation.vue";
import Imposto from "./Imposto.vue";

import OpcoesTributarias from "../shared/OpcoesTributarias.js";

import { mapMutations, mapActions, mapGetters } from "vuex";

export default {
    name: "ConfigCompany",
    components: {
        Alert,
        Molded,
        InputText,
        InputPassword,
        Button,
        Loading,
        Certificate,
        Taxation,
        NatureOperation,
        CompanyTaxation,
        Imposto,
        Notificacao,
        Cfop,
    },
    data() {
        return {
            activeTab: "comum",
            loading: true,
            urlCreate: "/api/v1/tax-document/config-company/createOrUpdate",
            urlGetById: "/api/v1/tax-document/config-company/get-by-id",
            companyTaxation: {},
            configCompany: {
                id: "",
                source: "prefeitura",
                loginPrefeitura: "",
                senhaPrefeitura: "",
                nacional: false,
                naturezaOperacao: { content: '', id: '' },
                codigoIndicadorOperacao: { content: '', id: '' },
                ibsCbsSituacaoTributaria: { content: '', id: '' },
                ibsCbsClassificacaoTributaria: { content: '', id: '' },
                codigoOpcaoSimplesNacional: { content: '', id: '' },
                regimeApuracaoTributariaSimplesNacional: { content: '', id: '' },
                regimeEspecialTributacaoMunicipal: { content: '', id: '' },
                tipoTributacao: { content: '', id: '' },
                situacaoTributariaPisCofins: { content: '', id: '' },
                pis: 0,
                cofins: 0,
                iss: 0,
                csll: 0,
                inss: 0,
                ir: 0,
                ibs: 0,
                cbs: 0,
                percentualTotalTributosFederais: 0,
                percentualTotalTributosEstaduais: 0,
                percentualTotalTributosMunicipais: 0
            },
            optionsNaturezaOperacao: [
                { content: 'Tributação no Município', id: '1' },
                { content: 'Tributação fora do Município', id: '2' },
                { content: 'Isenção', id: '3' },
                { content: 'Imune', id: '4' },
                { content: 'Exigibilidade Suspensa por Decisão Judicial', id: '5' },
                { content: 'Exigibilidade Suspensa por Procedimento Administrativo', id: '6' },
            ],
            optionsCodigoIndicadorOperacao: OpcoesTributarias.codigoIndicadorOperacao,
            optionsTributacaoIBSCBS: OpcoesTributarias.tributacaoIBSCBS,
            optionsClassificacaoTributaria: OpcoesTributarias.classificacaoTributaria,
            optionsCodigoOpcaoSimplesNacional: OpcoesTributarias.codigoOpcaoSimplesNacional,
            optionsTipoTributacao: OpcoesTributarias.tipoTributacao,
            optionsRegimeApuracaoTributariaSimplesNacional: OpcoesTributarias.regimeApuracaoTributariaSimplesNacional,
            optionsRegimeEspecialTributacaoMunicipal: OpcoesTributarias.regimeEspecialTributacaoMunicipal,
            optionsSituacaoTributariaPisCofins: OpcoesTributarias.situacaoTributariaPisCofins
        };
    },
    mounted() {
        this.getById();
        this.addLoading(["panel"]);
    },
    computed: {
        ...mapGetters("generic", ["event"]),
        ehSimplesNacional() {
            return this.companyTaxation.simplesNacional.content == "Sim";
        },
    },
    methods: {
        ...mapActions("generic", ["postApi", "putApi", "getApi"]),
        ...mapMutations("generic", ["addLoading", "removeLoading"]),
        getById() {
            this.loading = true;
            let params = { url: this.urlGetById, obj: {} };
            this.getApi(params).then((response) => {
                if (response.success) {
                    let data = response.content;
                    if (data == null) {
                        this.loading = false;
                        return;
                    }
                    let configCompany = {};

                    configCompany = {
                        id: data.id,
                        source: "prefeitura",
                        urlPrefeitura: data.urlPrefeitura,
                        loginPrefeitura: data.loginPrefeitura,
                        senhaPrefeitura: data.senhaPrefeitura,
                        nacional: data.nacional,

                        naturezaOperacao: this.optionsNaturezaOperacao.find(x => x.id == data.naturezaOperacao.toString()) || { content: 'Tributação no Município', id: '1' },
                       
                        codigoIndicadorOperacao: this.optionsCodigoIndicadorOperacao.find(x => x.id == data.codigoIndicadorOperacao) || { content: "010101 - Bem Móvel Material - Presencial, com retirada no estabelecimento do fornecedor", id: "010101" },
                        ibsCbsSituacaoTributaria: this.optionsTributacaoIBSCBS.find(x => x.id == data.ibsCbsSituacaoTributaria) || { content: "000 - Tributação integral", id: "000" },
                        ibsCbsClassificacaoTributaria: this.optionsClassificacaoTributaria.find(x => x.id == data.ibsCbsClassificacaoTributaria) || { content: "010001 - Operações do FGTS não realizadas pela Caixa Econômica Federal", id: "010001" },

                        codigoOpcaoSimplesNacional: this.optionsCodigoOpcaoSimplesNacional.find(x => x.id == data.codigoOpcaoSimplesNacional.toString()) || { content: 'Não Optante', id: '1' },
                        tipoTributacao: this.optionsTipoTributacao.find(x => x.id == data.tipoTributacao.toString()) || { content: 'Tributação no Município', id: '1' },
                        regimeApuracaoTributariaSimplesNacional: this.optionsRegimeApuracaoTributariaSimplesNacional.find(x => x.id == data.regimeApuracaoTributariaSimplesNacional.toString()) || { content: 'Federais e municipal pelo SN', id: '1' },
                        regimeEspecialTributacaoMunicipal: this.optionsRegimeEspecialTributacaoMunicipal.find(x => x.id == data.regimeEspecialTributacaoMunicipal.toString()) || { content: 'Nenhum', id: '0' },
                        situacaoTributariaPisCofins: this.optionsSituacaoTributariaPisCofins.find(x => x.id == data.situacaoTributariaPisCofins.toString()) || { content: 'Operação Tributável com Alíquota Básica', id: '1' },
                        percentualTotalTributosFederais: data.percentualTotalTributosFederais,
                        percentualTotalTributosEstaduais: data.percentualTotalTributosEstaduais,
                        percentualTotalTributosMunicipais: data.percentualTotalTributosMunicipais,

                        iss: data.iss,
                        pis: data.pis,
                        cofins: data.cofins,
                        csll: data.csll,
                        inss: data.inss,
                        ir: data.ir,
                        ibs: data.ibs,
                        cbs: data.cbs,
                    };

                    this.configCompany = configCompany;
                    this.loading = false;
                }
            });
        },
        saveCompany() {
            console.log(this.configCompany);


            let params = { url: this.urlCreate, obj: this.configCompany };
            this.postApi(params).then(() => {
                this.removeLoading(["btnSaveCompany"]);
            });
        },
    },
};
</script>

<style scoped>
.nfs-layout {
    display: grid;
    grid-template-columns: 200px 1fr;
    gap: 20px;
}

.nfs-side-nav {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-top: 12px;
}

.nfs-side-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 12px;
    border: 0px solid #e6e6e6;
    background: #f8f9fa;
    border-radius: 20px 0px 0px 20px;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease, transform 0.02s;
    font-size: 14px;
    font-weight: 500;
    color: #757d8c;
    width: 100%;
    text-align: left;
}

.nfs-side-item i {
    width: 16px;
    text-align: center;
    font-size: 14px;
}

.nfs-side-item.active {
    background: #E3E5ED;
    color: #577696;
    font-weight: 500;
}

.nfs-content {
    background: #fff;
    border: 1px solid #eee;
    border-radius: 10px;
    padding: 14px;
    margin-left: -20px;
}

.nfs-subtabs {
    border-bottom: 1px solid #eaeaea !important;
    margin-bottom: 6px;
}

.nfs-subcontent {
    padding-top: 10px;
}

.nfs-div-alert {
    margin-top: 10px;
}

.nfs-icon-tab-nfse {
    color: #355472 !important;
}

.nfs-div-btn-save {
    margin-top: 20px;
}

@media (max-width: 992px) {
    .nfs-layout {
        grid-template-columns: 1fr;
    }

    .nfs-side-nav {
        flex-direction: row;
        flex-wrap: wrap;
    }

    .nfs-side-item {
        flex: 1 1 auto;
    }
}
</style>
